<button class="button" on:click>
    <span>
        Retour 
    </span>
</button>

<style>
    .button {
        margin: 10%;
        border-radius: 5px;
        padding: 10px;
        border: 2px solid var(--color-primary);
        transition: all 0.4s;
        background-color: var(--color-primary);
        color: var(--color-white);
        font-size: 2vw;
        cursor: pointer;
        box-shadow: 2px 2px 4px 2px var(--color-grey);
    }

    .button:hover {
        color: var(--color-primary);
        background-color: var(--color-white);
    }

    .button span {
        cursor: pointer;
        display: inline-block;
        position: relative;
        transition: 0.4s;
    }

    .button span:after {
        content: '\002039';
        position: absolute;
        opacity: 0;
        top: 0;
        left: -20px;
        transition: 0.4s;
    }

    .button:hover span {
        padding-left: 10px;
    }

    .button:hover span:after {
        opacity: 1;
        left: 0;
    }

    @media only screen and (min-width: 768px) {
        .button {
            font-size: 1.5vw;
        }

        .button:hover span {
            padding-left: 15px;
        }
    }

    @media only screen and (min-width: 1850px) {
        .button {
            font-size: 26px;
        }
    }
</style>